<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->

<section id="tabs">
  <div style="width:96%; margin-left:auto;margin-right:auto">
    <div class="col-xs-12">
      <div class="head_title"> Monthly View for Supplier </div>
    </div>
    <br/>
    <div class="row">
      <div class="col-xs-12 " style="margin-left: 16px;">
        <nav>
          <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active width-dim" id="nav-weight-tab" data-toggle="tab" href="#nav-weight" role="tab" aria-controls="nav-weight"
              aria-selected="true">Weight</a>
            <a class="nav-item nav-link width-dim" id="nav-volume-tab" data-toggle="tab" href="#nav-volume" role="tab" aria-controls="nav-volume"
              aria-selected="false">Volume</a>
            <a class="nav-item nav-link width-dim" id="nav-noofparts-tab" data-toggle="tab" href="#nav-noofparts" role="tab" aria-controls="nav-noofparts"
              aria-selected="false">Number of Parts</a>
          </div>
        </nav>

        <form name="form" (ngSubmit)="updatemonthlyView()" #f="ngForm" novalidate>
          <div class="row no-mar-lr">
            <div class="form-group col-md-2 mar-top-30">
              <label>SupplierCode</label>
              <ng-multiselect-dropdown  name="suppliercodes"  [(ngModel)]="suppliercodes" [settings]="settingssuppliercode" [data]="supplierCodeList"
                (onSelect)="onSingleSelectSupplierCode($event)" (onDeSelect)="onDeSelectSupplierCode($event)" (onSelectAll)="onSelectAllSupplierCode($event)"
                (onDeSelectAll)="DeSelectAllSupplierCode($event)"></ng-multiselect-dropdown>
            </div>
            <div class="form-group col-md-2 mar-top-30">
              <label>Select Month</label>
              <ng-multiselect-dropdown  name="monthcode"  [(ngModel)]="monthnames" [settings]="settingsmonthCode" [data]="monthCodeList"
                (onSelect)="onSingleSelectmonth($event)" (onDeSelect)="onDeSelectmonth($event)" ></ng-multiselect-dropdown>
            </div>
            <div class="form-group col-md-2 mar-top-30">
              <label>Location</label>
              <ng-multiselect-dropdown name="locationnames" [(ngModel)]="locationnames" [settings]="settingslocation" [data]="locationCodeList" 
                (onSelect)="onSingleSelectLocation($event)" (onDeSelect)="onDeSelectLocation($event)" (onSelectAll)="onSelectAllLocation($event)"
                (onDeSelectAll)="DeSelectAllLocation($event)"></ng-multiselect-dropdown>
            </div>


            <div class="form-group col-md-2 " style="margin-top:63px">
              <label>&nbsp;</label>
              <button type="submit" value="Register" class="btn btn-primary black">Apply</button>
            </div>
          </div>
        </form>


        <div class="tab-content " id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-weight" role="tabpanel" aria-labelledby="nav-weight-tab">
            <div style="display: block">
              <span  class= "alin-center">y-axis ~ Weight in kg</span>
              <p-chart type="bar" [data]="data" [options]="barChartOptions"></p-chart>
              <br />
            </div>
          </div>
          <div class="tab-pane fade" id="nav-volume" role="tabpanel" aria-labelledby="nav-volume-tab">
            <div style="display: block">
                <span  class= "alin-center">y-axis ~ Volume in metric cube</span>
              <p-chart type="bar" [data]="data"></p-chart>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-noofparts" role="tabpanel" aria-labelledby="nav-noofparts-tab">
            <div style="display: block">
                <span  class= "alin-center">y-axis ~ Parts in Numbers</span>
              <p-chart type="bar" [data]="data"></p-chart>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>